export default __webpack_public_path__ + "static/media/red-arrow.7c2459e0.svg";